import Component from '@bythepixel/component-loader';
import Swiper, {
  Pagination, Navigation, Thumbs,
} from 'swiper';

Swiper.use([Pagination, Navigation, Thumbs]);

const selectors = {
  sliderEl: '[data-comp-thumbs-gallery]',
  galleryTopEl: '[data-gallery-top]',
  galleryThumbsEl: '[data-gallery-thumbs]',
  nextEl: '[data-navigation-next-el]',
  prevEl: '[data-navigation-prev-el]',
  paginationEl: '[data-pagination-el]',
  swiperSlide: '.swiper-slide',
};

export default class thumbsGallery extends Component {
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    if (this.$container.querySelector(selectors.galleryThumbsEl)) {
      this.thumbsGallerySlider = new Swiper(selectors.galleryThumbsEl, {
        spaceBetween: 10,
        slidesPerView: 3,
        allowTouchMove: false,
        breakpoints: {
          // when window width is >= 1200px
          1200: {
            slidesPerView: 4,
          },
        },
      });
    }
    if (this.$container.querySelector(selectors.galleryTopEl)) {
      this.topGallerySlider = new Swiper(selectors.galleryTopEl, {
        spaceBetween: 10,
        thumbs: {
          swiper: this.thumbsGallerySlider,
        },
        navigation: {
          nextEl: selectors.nextEl,
          prevEl: selectors.prevEl,
        },
        pagination: {
          el: selectors.paginationEl,
          clickable: true,
        },
      });
    }
    if (this.thumbsGallerySlider && this.topGallerySlider) {
      this.addSlideChangeListener();
      this.addSlideThumbnailClickListener();
    }
    triggerWindowResize(); // Trigger window resize after timeout to correct visual errors in case that JS loaded before CSS
  }

  addSlideChangeListener() {
    this.thumbsGallerySlider.on('slideChange', () => {
      window.dispatchEvent(new Event('resize'));
    });

    this.topGallerySlider.on('slideChange', () => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  addSlideThumbnailClickListener() {
    const swiperSlides = this.$container.querySelectorAll(selectors.swiperSlide);
    const totalSwiperSlides = swiperSlides.length;
    let swiperSlideCounter = 0;
    swiperSlides.forEach(swiperSlide => {
      const slideIndex = swiperSlideCounter;
      swiperSlide.addEventListener('mousedown', () => {
        this.topGallerySlider.slideTo(slideIndex - (totalSwiperSlides / 2));
      });
      swiperSlideCounter += 1;
    });
  }
}

function triggerWindowResize() {
  window.setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
}
